import { mockSHAssignmentViewCJMMRecord } from 'mock-data/performancereport/shAssignmentCjmm/stage';
import { rest } from 'msw';
export var stageHandler = [
    rest.get('/sh-assignment-cjmm', function (req, res, ctx) {
        return res(ctx.status(200), ctx.json(mockSHAssignmentViewCJMMRecord));
    })
];
